module.exports = __webpack_public_path__ + "static/media/12.e2caf4fe.png";